import React, { FunctionComponent, useState, useEffect } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_one, fetch_all, fetch_all_with_count } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import {
  Box,
  Button as Btn,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
} from '@mui/material';

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import {
  Button,
  DataGrid,
  DatePicker,
  Dt,
  Fab,
  FileDrop,
  FileUpload,
  IconButton,
  Page,
  Typography
} from '../../../components/v2/styled';

import { BloodUpload } from '../../../models/BloodUpload';
import { GridColDef } from '@mui/x-data-grid-pro';
import { SnackSaved } from '../../../components/v2/snacks/Saved';
import { SnackDestroyed } from '../../../components/v2/snacks/Destroyed';
import { Consent } from '../../../models/Consent';
import Visibility from '@mui/icons-material/Visibility';
import Launch from '@mui/icons-material/Launch';

const { DateTime } = require("luxon");

type Props = {}

export const ClientMeasuresBlood: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();

  const [editing, setEditing] = useState<boolean>(false);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);
  const [mainObject, setMainObject] = useState<BloodUpload>({
    user_id: login?.id,
    date: DateTime.now().toFormat("dd/LL/y"),
    hide_practices: ""
  });

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("date DESC");
  const [search, setSearch] = useState<string>("");

  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["blood_uploads", login?.id, {page: page, order: order}],
    queryFn: () =>
      fetch_all_with_count<BloodUpload>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'blood_upload',
          fields: ['id', 'created_at', 'get_item', 'date', 'hide_practices', 'item_file_name', 'user_id', 'practice'],
          sub_fields: {
            practice: ['id', 'name']
          },
          order: order,
          per_page: 20,
          page: page,
          filter: {
            search: search,
            advanced: {
              user_id: login?.id
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result
    },
    enabled: !!login?.id,
  });
  const {
    data: myPractices,
    // isLoading: objectsLoading,
    // isError: objectsError,
    // isSuccess: objectsSuccess,
    // refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["my_practices_for_dashboard", login?.practice_id],
    queryFn: () =>
      fetch_all<Consent>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'consent',
          fields: ['id', 'practice', 'practice_id', 'enabled', 'is_blood'],
          sub_fields: {
            practice: ['id', 'name', 'get_medium', 'item_is_square', 'url_path']
          },
          filter: {
            search: '',
            advanced: {
              user_id: login?.id
            }
          }
        },
        login
      ),
    enabled: !!login && login.type === "User::User"
  });








  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<BloodUpload>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      objectsRefetch();
      setDestroyedOpen(true);
    },
  });
  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean
    }) => {
      return fetch_one<BloodUpload>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      setEditing(false);
      setMainObject({
        user_id: login?.id,
        hide_practices: `,${(myPractices || []).filter(fff => !fff.is_blood).map(mmm => mmm.practice_id).join(",")},`
      });
      objectsRefetch();
    },
  });







  useEffect(() => {
    if (!!mainObject?.id && !!editing) {
      setMainObject((objects || []).filter(fff => fff.id === mainObject?.id)[0]);
    }
  }, [objects]);
  useEffect(() => {
    setMainObject({
      ...mainObject,
      hide_practices: `,${(myPractices || []).filter(fff => !fff.is_blood).map(mmm => mmm.practice_id).join(",")},`
    });
  }, [myPractices]);

  const columns: GridColDef[] = [
    // { field: 'id', headerName: '#', width: 80, renderCell: params => <>
    //   <Typography sx={{lineHeight: '48px'}}>{params.row.id}{(params.row.extra_data?.chat || []).length > 0 && <Badge color="primary" badgeContent={(params.row.extra_data?.chat || []).length}><NotificationImportantIcon color="primary" sx={{marginLeft: 1}} /></Badge>}</Typography>
    // </> },
    { field: 'created_at', headerName: t("client.models.blood.created_at"), width: 200, renderCell: params => <>
      <Dt d={params.row.created_at} f="DDD t" />
    </> },
    { field: 'date', headerName: t("client.models.blood.date"), width: 200, renderCell: params => <>
      <Dt d={params.row.date} f="DDD" />
    </> },
    { field: 'practice_name', headerName: t("coach.models.blood.practice"), width: 200 },
  ];
  
  return <Page
    title={t("general.blood_uploads.title")}
  >
    {!!editing && <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Typography sx={{
            fontSize: '0.7rem'
          }}>{t("client.models.blood_uploads.date")}</Typography>
          <DatePicker
            // placeholder="DD/MM/YY"
            // autoOk={true}
            disableFuture={false}
            openTo="year"
            label={t("client.models.blood_uploads.date")}
            format={"dd/LL/y"}
            views={["year", "month", "day"]}
            setValue={(e) => {
              setMainObject({
                ...mainObject,
                date: e
              });
            }}
            value={(mainObject?.date || '').indexOf("-") > -1 ? DateTime.fromFormat(mainObject.date, "y-LL-dd").toFormat("dd/LL/y") : mainObject.date || DateTime.now().toFormat("dd/LL/y")}
            id="option_date"
            sx={{
              box: {
                width: 'auto',
                display: 'inline-block'
              },
              field_box: {
                "svg": {
                  display: 'none'
                }
              },
              field: {
                width: 'auto',
                marginTop: 0,
                "input": {
                  textAlign: 'center'
                },
                backgroundColor: 'white'
              }
            }}
          />
        </Grid>

        <Grid item xs={12} md={8}>
          {!mainObject?.id && <>
            <Typography sx={{fontSize: '14px'}}>{t("general.blood_uploads.fields.item", "Bijlage")}</Typography>
            <FileDrop
              onDrop={acceptedFiles => {
                setMainObject({
                  ...mainObject,
                  item: acceptedFiles[0] as File
                });
              }}
              multiple={false}
              maxSize={10 * 1000 * 1000}
              items={!!mainObject?.item ? [mainObject?.item] : []}
              dropText="Click/Drop"
              dropHint="All.: all files, < 10mb"
            />
          </>}
          {!mainObject?.id && <Typography variant="caption" html>{t("coach.models.blood.attachment_help")}</Typography>}
          {!!mainObject.item_file_name && <Typography variant="caption" sx={{fontStyle: 'italic', display: 'block'}}>Current: {mainObject.item_file_name}</Typography>}
          {!!mainObject.get_item && <iframe src={mainObject.get_item} style={{width: '100%', height: '300px'}} />}
          {!!mainObject.get_item && <Button
            label={t("shared.buttons.open_in_new_tab")}
            id='open_in_new_tab'
            onClick={(v) => {
              window.open(mainObject.get_item, "_BLANK");
            }}
            startIcon={<Launch/>}
            sx={{marginTop: 1}}
          />}
        </Grid>
        {/* <Grid item xs={12} md={8}>
          {!mainObject?.id && <FileUpload
            caption={t("general.blood_uploads.fields.item", "Bijlage")}
            fileInputName='item'
            selected={mainObject.item}
            onChange={(f) => {
              setMainObject({
                ...mainObject,
                item: f as File
              });
            }}
          />}
          {!mainObject?.id && <Typography variant="caption" html>{t("client.models.blood.attachment_help")}</Typography>}
          {!!mainObject.item_file_name && <Typography variant="caption" sx={{fontStyle: 'italic', display: 'block'}}>Current: {mainObject.item_file_name}</Typography>}
          {!!mainObject.get_item && <iframe src={mainObject.get_item} style={{width: '100%', height: '300px'}} />}
          {!!mainObject.get_item && <Button
            label={t("shared.buttons.open_in_new_tab")}
            id='open_in_new_tab'
            onClick={(v) => {
              window.open(mainObject.get_item, "_BLANK");
            }}
            startIcon={<Launch/>}
            sx={{marginTop: 1}}
          />}
        </Grid> */}

        <Grid item xs={12}>
          <Typography sx={{
            fontSize: '0.7rem'
          }}>{t("client.models.blood_uploads.for_practices")}</Typography>
          {(myPractices || []).filter(fff => fff.enabled).map(consent => <Grid item xs={12}>
            <Checkbox checked={(mainObject.hide_practices || '').split(",").indexOf(consent.practice_id?.toString() || '') < 0} onChange={(e) => {
              if (!!e.target.checked) {
                let oldIds = (mainObject.hide_practices || '').split(",").filter(fff => !!fff);

                setMainObject({
                  ...mainObject,
                  hide_practices: `,${oldIds.filter(fff => fff !== (consent.practice_id?.toString() || '')).join(",")},`
                });
              }
              if (!e.target.checked) {
                let oldIds = (mainObject.hide_practices || '').split(",").filter(fff => !!fff);

                setMainObject({
                  ...mainObject,
                  hide_practices: `,${[...oldIds, consent.practice_id].join(",")},`
                });
              }
            }} />
            <Typography html sx={{display: 'inline-block', cursor: 'pointer'}} onClick={(e) => {
              if ((mainObject.hide_practices || '').split(",").indexOf(consent.practice_id?.toString() || '') > -1) {
                let oldIds = (mainObject.hide_practices || '').split(",").filter(fff => !!fff);

                setMainObject({
                  ...mainObject,
                  hide_practices: `,${oldIds.filter(fff => fff !== (consent.practice_id?.toString() || '')).join(",")},`
                });
              }
              if ((mainObject.hide_practices || '').split(",").indexOf(consent.practice_id?.toString() || '') < 0) {
                let oldIds = (mainObject.hide_practices || '').split(",").filter(fff => !!fff);

                setMainObject({
                  ...mainObject,
                  hide_practices: `,${[...oldIds, consent.practice_id].join(",")},`
                });
              }
            }}>{consent.practice?.name}</Typography>
          </Grid>)}
        </Grid>


        



        <Grid item xs={12} sx={{
          alignContent: 'baseline',
          textAlign: 'center',
          position: {
              xs: 'relative',
              md: 'sticky'
            },
          bottom: '-24px',
          backgroundColor: 'white',
          zIndex: 1201
        }}>
          <Divider sx={{marginTop: 1, marginBottom: 0}} />

          {!!mutationSave.isPending && <CircularProgress />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.save")}
            id='save'
            disabled={!mainObject.id ? !mainObject.item : false}
            contained
            onClick={(v) => {
              let formData = new FormData();
              formData.append('object', 'blood_upload');
              formData.append('handler_id', (login?.id || "").toString());
              formData.append('fields[]', 'id');
              if (!!mainObject?.id) formData.append('ob[id]', mainObject?.id.toString());
              if (!!mainObject?.id) formData.append('id', mainObject?.id.toString());
              // mainObject
              formData.append('ob[date]', mainObject?.date || '');
              formData.append('ob[hide_practices]', mainObject?.hide_practices || '');
              formData.append('ob[user_id]', mainObject?.user_id?.toString() || '');
              if (!!mainObject?.item) formData.append(`ob[item]`, mainObject?.item);

              mutationSave.mutate({
                formData: formData
              });
            }}
            sx={{marginBottom: 1, marginTop: 1}}
          />}
          {!mutationSave.isPending && <Button
            label={t(!!mainObject?.id ? "shared.buttons.back" : "shared.buttons.cancel")}
            id='cancel'
            text
            // contained
            onClick={(v) => {
              setEditing(false);
              setMainObject({
                user_id: login?.id,
              });
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
        </Grid>

      </Grid>
    </>}
    {!editing && <>
      <DataGrid
        action_count={2}
        hideCount
        actions={(params) => {
          return (<>
            {!!params.row?.practice?.id && <IconButton title="View" color="default" onClick={() => {
              window.open(params.row.get_item, "_BLANK");
            }}>
              <Visibility />
            </IconButton>}
            {!params.row?.practice?.id && <IconButton title="Edit" color="default" onClick={() => {
              setMainObject(params.row);
              setEditing(true);
            }}>
              <EditIcon />
            </IconButton>}
            {!params.row?.practice?.id && <IconButton title="Remove" destroyBtn color="default" onClick={() => {
              mutationDestroy.mutate({
                formData: {
                  object: 'blood_upload',
                  id: params.row.id,
                  ob: {
                    id: params.row.id,
                  }
                }
              });
            }}>
              <DeleteIcon />
            </IconButton>}
          </>);
        }}
        objectCount={count}
        getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
        objects={(objects || []).map(u => ({
          ...u,
          practice_name: u.practice?.name
          // enabled: (u.status || 0) < 3
        }))}
        columns={columns}
        loader={objectsLoading}
        onSortModelChange={(a, b) => {
          let a_0_field:string = a[0].field;
          if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
          setOrder([a_0_field, a[0].sort].join(' '));
        }}
        page={page}
        setPage={(p) => {setPage(p);}}
      />

      <Fab
        onClick={() => {
          setEditing(true);
        }}
      />
    </>}
    
    <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Page>;
}

